import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { FileData } from '@services/FinancialService';

enum ReportMonthlyMessageEnum {
  PROCESSING = 'Processing',
  ERROR = 'Error',
}

interface CarnetComplementRowProps {
  pdfFiles: FileData[];
  csvFiles: FileData[];
  txtFiles: FileData[];
  handleOpenFiles: (file?: FileData[]) => void;
}

const REPORT_MONTHLY_MESSAGE_COLOR: Record<ReportMonthlyMessageEnum, string> = {
  [ReportMonthlyMessageEnum.ERROR]: NEW_COLORS.SEMANTICS.ERROR[500],
  [ReportMonthlyMessageEnum.PROCESSING]: NEW_COLORS.SECONDARY[400],
};

const REMITTANCE_MIGRATION = '-2';

export {
  REPORT_MONTHLY_MESSAGE_COLOR,
  REMITTANCE_MIGRATION,
  CarnetComplementRowProps,
  ReportMonthlyMessageEnum,
};
